export default __webpack_public_path__ + "static/media/teams-image.9445d807.png";